import { v4 as UUID } from 'uuid';
import { API, ENDPOINTS } from '@/app/services/api-url';
import EventBus from '@/app/eventBus';
import { capitalize } from '@/app/filters/filters';

export default {
  name: 'chosen-fund-modal',
  data: () => ({
    fundName: '',
    members: [],
    trustees: [],
    type: '',
    companyName: '',
    isLoading: false,
  }),
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    inputType: {
      type: String,
      required: true,
    },
  },
  methods: {
    dismiss() {
      this.$emit('close');
    },
    async confirm() {
      await this.submitFund();
      this.$emit('nextStep');
    },
    getCurrentFinYear() {
      const finYearStart = new Date(new Date().getFullYear(), 6, 1);
      const dateToConsider = new Date();
      if (dateToConsider < finYearStart) {
        return dateToConsider.getFullYear();
      }
      return dateToConsider.getFullYear() + 1;
    },
    async loadFund() {
      this.isLoading = true;
      const { accessTokens } = this.$store.getters['account/getActiveAccountUser'];
      const submitAccessTokens = {};
      if (accessTokens.bgl !== undefined && this.inputType.toLowerCase().includes('bgl')) {
        submitAccessTokens.bgl = accessTokens.bgl;
      }
      if (accessTokens.class !== undefined && this.inputType.toLowerCase().includes('class')) {
        submitAccessTokens.class = accessTokens.class;
      }
      try {
        const response = await API.post(
          `${ENDPOINTS.POST_INTEGRATION_GET_FUNDS}/${this.id}/matched`,
          {
            accessTokens: submitAccessTokens,
            type: 'MT',
            financialYear: `${this.getCurrentFinYear()}`,
          },
        );
        if (response.status === 200) {
          this.fundName = response.data.fund.details.name;
          this.members = response.data.fund.members.map(item => ({
            title: capitalize(item.title || ''),
            dateOfBirth: new Date(item.dateOfBirth),
            firstName: item.firstName,
            middleName: item.middleName || '',
            lastName: item.lastName,
            sex: capitalize(item.sex || ''),
            integrationId: item.id,
            uuid: UUID(),
            isTrustee: item.isTrustee,
          }));
          this.trustees = response.data.fund.trustee.trustees.map(item => ({
            title: capitalize(item.title || ''),
            dateOfBirth: new Date(item.dateOfBirth),
            firstName: item.firstName,
            middleName: item.middleName || '',
            lastName: item.lastName,
            sex: capitalize(item.sex || ''),
            uuid: UUID(),
            integrationId: item.id,
          }));
          this.type = (response.data.fund.trustee.type !== null ? response.data.fund.trustee.type.toLowerCase() : '');
          this.companyName = (response.data.fund.trustee.company !== null && this.type === 'corporate' ? response.data.fund.trustee.company.name : '');
          this.isLoading = false;
        }
      } catch (err) {
        EventBus.$emit('addNotification', {
          title: 'Error loading fund',
          icon: 'cross',
          message: 'Could not load the chosen fund for display, please try again',
        });
        this.isLoading = false;
        console.log(err);
      }
    },
    async submitFund() {
      await this.$store.dispatch(
        'fund/updateFundDetails',
        {
          name: this.fundName,
        },
      );
      await this.$store.dispatch(
        'fund/updateFundMembers',
        this.members,
      );
      await this.$store.dispatch(
        'fund/updateFundTrustee',
        {
          type: this.type,
          trustees: this.trustees,
          company: { name: this.companyName },
        },
      );
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(value) {
        if (value !== '') {
          this.loadFund();
        }
      },
    },
  },
};
